export default class Theme {
    public static theme_primaryColor_hex = '#0093db';

    public static theme_secondaryColor_hex = '#78be20';
}
